// CheckboxWithLabel.js
import React, { useEffect, useState } from "react";
import { FaCheck } from "react-icons/fa";

const CheckboxWithLabel = ({ label, checkboxId, checked: initialChecked,setSelectedDays, onChange, indeterminate,cssClass,disabled }) => {
  const [isChecked, setIsChecked] = useState(initialChecked);

  useEffect(() => {
    setIsChecked(initialChecked);
  }, [initialChecked]);

  const handleCheckboxChange = () => {
    if (disabled) return;
    const newChecked = !isChecked;
    setIsChecked(newChecked);
      setSelectedDays((prevSelectedDays) => ({
      ...prevSelectedDays,
      [checkboxId]: isChecked,
    }));
    if (onChange) {
      onChange(checkboxId, newChecked);
    }
  };

  const gradientBackground = {
    background: `linear-gradient(to right, #617DC9, #344578)`,
  };

  const isCompact = cssClass?.includes('text-xs');
  const checkboxSize = isCompact ? 'w-4 h-4' : 'w-6 h-6';
  const iconSize = isCompact ? 'text-xs' : 'text-sm';
  const paddingClass = isCompact ? 'p-1' : 'p-2';
  const labelPadding = isCompact ? 'px-1.5' : 'px-3';

  return (
    <label
      htmlFor={checkboxId}
      onClick={handleCheckboxChange}
      className={`${cssClass || ''} capitalize flex items-center cursor-pointer text-sm border border-[#E4E4E4] ${paddingClass} rounded-lg inline-flex ${labelPadding}`}
    >
      <span className={`mr-2 text-[#7D7D7D] ${isCompact ? 'text-xs' : ''}`}>{label}</span>
      <div
        className={`${checkboxSize} ${isCompact ? 'p-0.5' : 'p-1'} border rounded-full transition duration-300 ease-in-out flex items-center justify-center flex-shrink-0`}
        style={isChecked ? gradientBackground : {}}
      >
        {isChecked && <FaCheck className={`text-white ${iconSize}`} />}
      </div>
      <input
        type="checkbox"
        id={checkboxId}
        className="hidden"
        // disabled={disabled}
        checked={isChecked}
        onChange={() => {}} 
        ref={(input) => {
          if (input) {
            input.indeterminate = indeterminate;
          }
        }}
      />
    </label>
  );
};

export default CheckboxWithLabel;
